import { useEffect } from "react";
import { Dayjs } from "../../../lib";
type ChartFilters = {
  chartId: string;
  filters: {
    period?: string;
    tags?: string[];
    category?: string;
    dateRange?: { start: Dayjs; end: Dayjs | null };
    zoomInterval?: { start: Dayjs; end: Dayjs | null };
  };
};

export const getSavedFilters = (chartId: string): ChartFilters["filters"] => {
  const chartType = chartId.split("-")[1];
  const parsed = JSON.parse(
    localStorage.getItem(`lineChartFilters ${chartType}`) ??
      `{"chartId":"${chartId}"}`
  );

  if (parsed.chartId === chartId) {
    return parsed.filters ?? {};
  }
  return {};
};

const useFiltersLocalStorage = (chartId: string) => {
  const saveOnLocalStorage = (
    filters: ChartFilters["filters"],
    newChartId: string
  ) => {
    const chartType = newChartId.split("-")[1];

    const previousFiltersParsed = JSON.parse(
      localStorage.getItem(`lineChartFilters ${chartType}`) ?? "{}"
    );
    const previousFilters =
      previousFiltersParsed.chartId === newChartId ? previousFiltersParsed : {};

    localStorage.setItem(
      `lineChartFilters ${chartType}`,
      JSON.stringify({
        filters: {
          ...previousFilters.filters,
          ...filters,
        },
        chartId: newChartId,
      })
    );
  };
  const clearLocalStorage = (chartType: string) => {
    localStorage.removeItem(`lineChartFilters ${chartType}`);
    localStorage.setItem(
      `lineChartFilters ${chartType}`,
      JSON.stringify({ chartId, category: undefined })
    );
  };
  useEffect(() => {
    const chartType = chartId.split("-")[1];
    const parsed = JSON.parse(
      localStorage.getItem(`lineChartFilters ${chartType}`) ??
        `{"chartId":"${chartId}"}`
    );

    if (parsed.chartId.includes(chartType) && parsed.chartId !== chartId) {
      clearLocalStorage(chartType);
    }
  }, [chartId]);

  return { getSavedFilters, saveOnLocalStorage, clearLocalStorage };
};

export default useFiltersLocalStorage;
